import { consumeCaching } from "@/lib/caches/consume"
import { consumeLoading } from "@/lib/consume/loading"
import { consumeRouter } from "@/lib/consume/router"
import { consumeGeolocation } from "@/lib/geolocation/consume"
import { Notices } from "@/lib/notices"
import { consumeServices } from "@/lib/services/consume"

import { BookingSearchContainerComponent } from "./component"

export const BookingSearchContainerConsumer = consumeLoading(
  consumeRouter(
    Notices.consumeFunctions(
      consumeGeolocation(
        consumeServices(consumeCaching(BookingSearchContainerComponent))
      )
    )
  )
)
